export const ONEID_ROUTES = {
  HOME: "/",
}

export const EXT_ROUTES = {
  LOGIN: "https://app.myoneid.fr/login",
}
